import React from "react";
import { IoLogoLinkedin, IoMdMail, IoIosFlask } from "react-icons/io";
import { Header } from "./style";

const HeaderElement = () => {
  const ano = new Date().getFullYear();

  return (
    <Header>
      <h1>
        <strong>Olá</strong>, meu nome é <strong>Rodrigo Antunes</strong>
      </h1>
      <h3>Desenvolvedor Front-End</h3>
      <div className="description">
        Trabalho há {ano - 2009} anos com Desenvolvimento Web. <br /> Gosto de
        criar experiências interativas utilizando HTML5, CSS3 e Javascript.
      </div>
      <div className="contato">
        <ul>
          <li>
            <IoLogoLinkedin />
          </li>
          <li>
            <IoMdMail />
          </li>
          <li>
            <IoIosFlask />
          </li>
        </ul>
      </div>
    </Header>
  );
};

export default HeaderElement;



// WEBPACK FOOTER //
// ./src/components/Header/index.js